import React from "react";
import style from "./style.module.scss";
import { formatCurrency } from "../../../../../../components/helper/helper";

const IC_GROUP_BADGE = {
  "Non Qual": style.badge_non_qual,
  "Mid Qual": style.badge_mid_qual,
  Qual: style.badge_merit,
  Merit: style.badge_merit,
};

const Row = ({ data }) => {
  return (
    <tr className={style.table_row}>
      <td className={style.table_cell}>{data?.ic_level}</td>
      <td className={style.table_cell}>{data?.mas_desc}</td>
      <td className={style.table_cell}>
        <span
          className={`${style.badge} ${IC_GROUP_BADGE[data?.ic_group] || ""}`}
        >
          {data?.ic_group}
        </span>
      </td>
      <td className={style.table_cell}>$ {formatCurrency(data?.qual_inc)}</td>
      <td className={style.table_cell}>$ {formatCurrency(data?.ic_inc)}</td>
      <td className={style.table_cell}>
        $ {formatCurrency(data?.total_disc_inc)}
      </td>
      <td className={style.table_cell}>
        {Number(data?.eff_rate ?? 0).toFixed(2)}%
      </td>
      <td className={style.table_cell}>$ {formatCurrency(data?.ic_exp)}</td>
      <td className={style.table_cell}>
        $ {formatCurrency(data?.disc_profit)}
      </td>
      <td className={style.table_cell}>
        {Number(data?.bankcard_trans ?? 0).toLocaleString()}
      </td>
      <td className={style.table_cell}>
        $ {formatCurrency(data?.bankcard_volume)}
      </td>
    </tr>
  );
};

export default Row;
